import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '@/hooks/use-cookie-consent';
import { Cookie, X } from 'lucide-react';

export const CookieConsent = () => {
  const { hasConsent, isLoading, acceptAll, acceptEssential } = useCookieConsent();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Delay showing banner for smooth entrance
    if (!isLoading && !hasConsent) {
      const timer = setTimeout(() => setIsVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, [isLoading, hasConsent]);

  if (isLoading || hasConsent) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 p-4 transition-transform duration-500 ease-out ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="max-w-4xl mx-auto bg-card border border-border rounded-lg shadow-2xl backdrop-blur-sm">
        <div className="p-4 sm:p-6">
          <div className="flex items-start gap-4">
            <div className="hidden sm:flex h-10 w-10 rounded-full bg-primary/10 items-center justify-center flex-shrink-0">
              <Cookie className="h-5 w-5 text-primary" />
            </div>
            
            <div className="flex-1 space-y-3">
              <h3 className="text-lg font-semibold text-foreground">Cookie Preferences</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                We use essential cookies for authentication and site functionality. 
                Additional cookies help us protect against bots using reCAPTCHA. 
                Read our{' '}
                <Link to="/privacy" className="text-primary hover:underline">
                  Privacy Policy
                </Link>{' '}
                for more details.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-3 pt-2">
                <Button
                  onClick={acceptAll}
                  className="w-full sm:w-auto"
                >
                  Accept All
                </Button>
                <Button
                  onClick={acceptEssential}
                  variant="outline"
                  className="w-full sm:w-auto"
                >
                  Essential Only
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
